<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--    CARD START-->
        <div>
            <div class="flex items-center">
                <div class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                    <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                        <IconPinSVG class="w-24 h-24"/>
                    </div>
                </div>

                <span class="ml-12 font-normal title-lg text-primary">{{ addressType }}</span>
            </div>

            <span class="mt-16 self-label">{{ $t('info.country') }}</span>
            <span class="text-base font-semibold sm:text-md">{{ address.country_name }}</span>

            <span class="mt-16 self-label">{{ $t('info.address') }}</span>
            <span class="text-base font-semibold sm:text-md">{{ addressLine }}</span>

            <span v-if="address.address_type_name === 'Billing'"
                  class="mt-16 self-label">{{ $t('info.e_invoices') }}</span>
            <span v-if="address.address_type_name === 'Billing'"
                  class="text-base font-semibold sm:text-md">{{
                    address.e_invoice ? $t('info.yes') : $t('info.no')
                }}</span>

            <button v-if="customerInfo.customertype === 'P'" :data-open-modal="this.getModalId()" class="mt-16 self-btn-plain">
      <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
          <IconPencilSVG/>
      </span>
                <span class="self-btn-plain__text">{{ $t('info.modify') }}</span>
            </button>
        </div>
        <!--    CARD END-->

        <!--     MODAL START -->
        <div class="micromodal" :id="this.getModalId()" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.modify') }} {{ addressType }}
                            {{ $t('info.address').toString().toLowerCase() }}{{ $i18n.locale == 'et' ? 'i' : '' }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close>
                <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                    <IconXSVG/>
                </span>
                        </button>
                    </header>
                    <div class="micromodal__content">

                        <div class="flex self-form-wrap">
                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label"
                                       for="asukohariik">{{ $t('info.country_of_residence') }}</label>
                                <div class="relative">
                                    <input type="text" id="asukohariik" placeholder="" name="asukohariik" :value="address.country_name"
                                           class="e5-input">
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="aadress">{{ $t('info.address') }}</label>
                                <div class="relative">
                                    <input type="text" id="aadress" placeholder="" name="aadress"
                                           :value="address.address_line1 + ', ' + address.territory_name" class="e5-input">
                                </div>
                            </div>

                            <div class="flex items-center justify-between w-full px-8 pt-16">
                                <div>
                                    <button class="self-btn-primary">
                                        {{ $t('info.save') }}

                                        <span class="text-yellow-300 self-btn-primary__icon">
                      <IconArrowAltSVG/>
                    </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close="" class="self-btn-plain">
                      <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                          <IconXSVG/>
                      </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!--    MODAL END-->
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import IconPencilSVG from '@/assets/static/icons-src/icon-pencil.svg'
import IconXSVG from '@/assets/static/icons-src/icon-x.svg'
import IconArrowAltSVG from '@/assets/static/icons-src/icon-arrow-alt.svg'
import IconPinSVG from '@/assets/static/icons-src/icon-pin.svg'
import { IAddresses } from '@/domain/IAddresses'
import { ICustomer } from '@/domain/ICustomer'

@Component({
    components: {
        IconPencilSVG,
        IconXSVG,
        IconArrowAltSVG,
        IconPinSVG
    }
})
export default class Address extends Vue {
    @Prop(Object) address!: IAddresses;

    get customerInfo(): ICustomer {
        return this.$store.getters.getCustomerInfo
    }

    get addressLine(): string {
        let addressLine = ""
        if (this.address.address_line1) {
            addressLine += this.address.address_line1.trim()
        }
        if (this.address.territory_name) {
            addressLine += ", " + this.address.territory_name.trim()
        }
        if (this.address.county_name) {
            addressLine += ", " + this.address.county_name.trim()
        }
        if (this.address.postal_code) {
            addressLine += ", " + this.address.postal_code
        }
        return addressLine
    }

    get addressType() {
        switch (this.address.address_type_name) {
        case "Postal":
            return this.$t('info.postal');
        case "Business":
            return this.$t('info.business');
        case "Billing":
            return this.$t('info.billing');
        default:
            return this.address.address_type_name
        }
    }

    // Function to generate unique ID for modal
    getModalId(address: IAddresses = this.address): string {
        return `modal_${address.address_line1}_${address.postal_code}_${address.country_code}_${address.country_name}_${address.territory_name}_${address.county_name}_${address.address_type_name}_${address.billing_allowed}_${address.delivery_allowed}`;
    }
}
</script>

<style scoped>

</style>
